import { render, staticRenderFns } from "./yearbook_router.vue?vue&type=template&id=6fec4fce"
import script from "./yearbook_router.vue?vue&type=script&lang=js"
export * from "./yearbook_router.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports